'use client';

import { c as _c } from "react/compiler-runtime";
import { useComments, useCreateComment, useDeleteComment } from '@/lib/hooks';
import { useSession } from '@/lib/auth-client';
import { CommentInput } from './CommentInput';
import { CommentList } from './CommentList';
interface CommentSectionProps {
  objectId: string;
  objectType: 'item' | 'collection' | 'entity' | 'collection_item' | 'submission' | 'content' | 'initiative';
  canComment?: boolean;
}
export function CommentSection(t0) {
  const $ = _c(29);
  const {
    objectId,
    objectType,
    canComment: t1
  } = t0;
  const canComment = t1 === undefined ? false : t1;
  const {
    data: session
  } = useSession();
  const {
    data: comments,
    isLoading
  } = useComments(objectId, objectType);
  const createComment = useCreateComment();
  const deleteComment = useDeleteComment();
  let t2;
  if ($[0] !== session?.user?.id) {
    t2 = session?.user?.id?.toString();
    $[0] = session?.user?.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const currentUserId = t2;
  const isApproved = (session?.user as any)?.approved === true;
  canComment && isApproved;
  let t3;
  if ($[2] !== createComment || $[3] !== objectId || $[4] !== objectType) {
    t3 = async content => {
      await createComment.mutateAsync({
        objectId,
        objectType,
        content
      });
    };
    $[2] = createComment;
    $[3] = objectId;
    $[4] = objectType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSubmit = t3;
  let t4;
  if ($[6] !== deleteComment || $[7] !== objectId || $[8] !== objectType) {
    t4 = async activityId => {
      await deleteComment.mutateAsync({
        activityId,
        objectId,
        objectType
      });
    };
    $[6] = deleteComment;
    $[7] = objectId;
    $[8] = objectType;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleDelete = t4;
  const t5 = comments && `(${comments.length})`;
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="flex items-center justify-between"><h3 className="text-lg font-semibold text-gray-900">Comments {t5}</h3></div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== canComment || $[13] !== createComment.isPending || $[14] !== handleSubmit || $[15] !== isApproved || $[16] !== session?.user) {
    t7 = !session?.user ? <div className="p-4 bg-gray-50 rounded-xl border border-gray-200"><p className="text-sm text-gray-600">Please sign in to leave a comment.</p></div> : !canComment ? <div className="p-4 bg-gray-50 rounded-xl border border-gray-200"><p className="text-sm text-gray-600">Comments are disabled for this content.</p></div> : !isApproved ? <div className="p-4 bg-amber-50 rounded-xl border border-amber-200"><p className="text-sm text-amber-800">Your account needs to be approved before you can comment.</p></div> : <CommentInput onSubmit={handleSubmit} isSubmitting={createComment.isPending} />;
    $[12] = canComment;
    $[13] = createComment.isPending;
    $[14] = handleSubmit;
    $[15] = isApproved;
    $[16] = session?.user;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== comments) {
    t8 = comments || [];
    $[18] = comments;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== currentUserId || $[21] !== handleDelete || $[22] !== isLoading || $[23] !== t8) {
    t9 = <CommentList comments={t8} currentUserId={currentUserId} onDelete={handleDelete} isLoading={isLoading} />;
    $[20] = currentUserId;
    $[21] = handleDelete;
    $[22] = isLoading;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t9) {
    t10 = <div className="space-y-6">{t6}{t7}{t9}</div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}